"use client";

import { cn } from "@/utils/utils/helpers";
import * as AccordionPrimitive from "@radix-ui/react-accordion";
import { Minus, Plus } from "lucide-react";
import * as React from "react";
const Accordion = AccordionPrimitive.Root;
const AccordionTrigger = AccordionPrimitive.Trigger;
const AccordionItem = React.forwardRef<React.ElementRef<typeof AccordionPrimitive.Item>, React.ComponentPropsWithoutRef<typeof AccordionPrimitive.Item>>(({
  className,
  ...props
}, ref) => <AccordionPrimitive.Item ref={ref} className={cn("border-b", className)} {...props} />);
AccordionItem.displayName = "AccordionItem";
const AccordionTriggerWithIcons = React.forwardRef<React.ElementRef<typeof AccordionPrimitive.Trigger>, React.ComponentPropsWithoutRef<typeof AccordionPrimitive.Trigger>>(({
  className,
  children,
  ...props
}, ref) => <AccordionPrimitive.Header className="flex">
    <AccordionPrimitive.Trigger ref={ref} className={cn("group flex flex-1 items-center justify-between py-4 font-medium transition-all", className)} {...props}>
      {children}
      <Plus className="block h-4 w-4 shrink-0 transition-transform duration-200 group-data-[state=open]:hidden" />
      <Minus className="hidden h-4 w-4 shrink-0 transition-transform duration-200 group-data-[state=open]:block" />
    </AccordionPrimitive.Trigger>
  </AccordionPrimitive.Header>);
AccordionTriggerWithIcons.displayName = "AccordionTriggerWithIcons";
const AccordionContent = React.forwardRef<React.ElementRef<typeof AccordionPrimitive.Content>, React.ComponentPropsWithoutRef<typeof AccordionPrimitive.Content>>(({
  className,
  children,
  ...props
}, ref) =>
// INFO: don't apply padding directly to AccordionPrimitive.Content, otherwise it will cause stuturing, so we add an additional div
<AccordionPrimitive.Content ref={ref} className="overflow-hidden text-sm transition-all data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down" {...props}>
    <div className={className}>{children}</div>
  </AccordionPrimitive.Content>);
AccordionContent.displayName = AccordionPrimitive.Content.displayName;
export { Accordion, AccordionContent, AccordionItem, AccordionTrigger, AccordionTriggerWithIcons };